/**
 * デジタルサイネージ用モジュール
 *
 * @module app/signage/display/SignageShelterOverviewPage
 */
define(['module',
        'dojo',
        'dojo/_base/array',
        'dojo/_base/declare',
        'dojo/_base/lang',
        'dojo/dom-class',
        'dojo/dom-construct',
        'dojo/dom-style',
        'dojo/text!./templates/SignageShelterOverviewPage.html',
        'idis/service/Requester',
        'idis/view/Loader',
        '../_SignageBase',
        //'../../config',
        // 以下、変数で受けないモジュール
        'dijit/Dialog',
        'dijit/form/Form',
        'dijit/layout/BorderContainer',
        'dijit/layout/ContentPane',
        'idis/view/form/AclButton',
], function(module, dojo, array, declare, lang, domClass, domConstruct, domStyle, template, Requester, Loader, _SignageBase) {

        // 前回表示データ
        // セッションストレージ等に保持するほうが良いか？
        var prevItemStore = {};

        /**
         *
         * @class SignageShelterOverivewPage
         * @extends module:idis/view/page/_PageBase~_PageBase
         */
        return declare(module.id.replace(/\//g, '.'), _SignageBase,
        /** @lends module:app/signage/display/SignageShelterOverviewPage~SignageShelterOverviewPage# */
        {
            // テンプレート文字列
            templateString: template,

            _timer: null,

            // 表示ページ
            _page: 0,

            // ページあたり表示件数
            PAGE_LIST_SIZE: 9,

            // ページ切替間隔時間（秒）
            SIGNAGE_UPDATE_INTERVAL: 10,

            // 値を表示する項目のリスト
            target: [
                {'item':'prefOpeningShelterMunicNum', 'area':'prefOpeningShelterMunicNumArea'},
                {'item':'prefOpeningShelterNum', 'area':'prefOpeningShelterNumArea'},
                {'item':'prefEvacHouseholdNum', 'area':'prefEvacHouseholdNumArea'},
                {'item':'prefEvaqueeNum', 'area':'prefEvaqueeNumArea'},
            ],

            // ルート要素に付与されるCSS
            baseClass: 'idis-Page idis-Page--signage',

            constructor: function() {
                this.inherited(arguments);
            },

            buildRendering: function() {
                this.inherited(arguments);
            },

            startup: function() {
                this.inherited(arguments);
                this.initPage();
            },

            destroy: function() {
                this.inherited(arguments);
                clearTimeout(this._timer);
            },

            /**
             * 画面表示
             */
            initPage: function() {
                this.setShelterOviewviewInfo();
            },

            /**
             * 避難所概況情報を設定します
             */
            setShelterOviewviewInfo: function() {
                var promise = Requester.get('/data/signage/' + this._screenId +'.json', {
                    headers: {'Content-Type': 'application/json; charset=utf-8'},
                    handleAs: 'json',
                    preventCache : true
                }).then(lang.hitch(this, function (item) {
                    // 避難所情報を設定
                    var prefShelterInfo = item.items.filter(function(element) {
                        return element.municipalityCd === null;
                    });
                    this.setPrefShelterInfo(this, prefShelterInfo);
                    var municShelterInfo = item.items.filter(function(element) {
                        return element.municipalityCd !== null;
                    });
                    this.setMunicShelterInfo(this, municShelterInfo);
                    // 前回データを更新
                    prevItemStore[this._screenId] = item;

                }), function (error) {
                    if (error.response.status === 404) {
                        var prefShelterInfo = {};
                        this.setPrefShelterInfo(this, prefShelterInfo);
                        var municShelterInfo = [];
                        this.setMunicShelterInfo(this, municShelterInfo);
                    } else {
                        this.chain.info('情報の取得に失敗しました。', 'エラー');
                    }
                });
                //ローダーの表示
                Loader.wait(promise);
            },

            /**
             * 県の避難所情報を設定します
             */
            setPrefShelterInfo: function(self, item) {
                // 項目に取得した値を設定
                array.forEach(this.target, function(target){
                    self[target.item].innerHTML = item[0][target.item];
                });


                // 更新状態を設定
                this.setPrefShelterInfoUpdate(self, item);
            },

            /**
             * 県の避難所情報の更新状態を設定します
             */
            setPrefShelterInfoUpdate: function(self, item) {
                var updateFlg = false;
                // 前回データがある場合のみ処理
                // 前回データがない場合（≒初回表示）は処理しない
                var prevItem = prevItemStore[this._screenId];
                if (!prevItem) {
                    return;
                }
                var prefShelterInfo = prevItem.items[0];
                if (prefShelterInfo) {
                    array.forEach(this.target, function(target){
                        // 更新された項目にstyleを設定
                        if (prefShelterInfo[target.item] !== item[0][target.item]) {
                            domClass.add(self[target.area], 'update-column');
                            updateFlg = true;
                        } else {
                            domClass.remove(self[target.area], 'update-column');
                        }
                    });
                }
                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }
            },

            /**
             * 避難所情報一覧を設定します
             */
            setMunicShelterInfo: function(self, data) {
                // 表示をクリア
                var shelterOverviewTBody = dojo.byId('shelterOverviewTBody');
                domConstruct.empty(shelterOverviewTBody);

                // 表示対象ページの抽出
                var firstIndex = this.PAGE_LIST_SIZE * this._page;
                var lastIndex = this.PAGE_LIST_SIZE * (this._page + 1) - 1;
                var displayData = data.filter((element, index) =>
                    index >= firstIndex && index <= lastIndex
                );

                // 画面上のページ数表示
                if (data.length <= this.PAGE_LIST_SIZE) {
                    domStyle.set(this.pageArea, 'display', 'none');
                } else {
                    self.currentPage.innerHTML = this._page + 1;
                    self.totalPage.innerHTML = Math.ceil(data.length / this.PAGE_LIST_SIZE);    
                }

                var prevItem = prevItemStore[this._screenId];
                var shelterOverview = [];
                if (prevItem) {
                    shelterOverview = prevItem.items.filter(function(element) {
                        return element.municipalityCd !== null;
                    });
                }
                var updateFlg = false;

                array.forEach(displayData, function(item){
                    // 避難所の前回値
                    var shelterPrevItem = null;
                    if (shelterOverview && shelterOverview.length > 0) {
                        shelterPrevItem = shelterOverview.filter((element) =>
                            element.municipalityCd === item.municipalityCd
                        )[0];
                        // 新規のデータが追加された場合は前回値を空文字として設定
                        if (shelterPrevItem === undefined) {
                            shelterPrevItem = {
                                "municipalityName": "", 
                                "municOpeningShelterNum": "", 
                                "municEvacHouseholdNum": "", 
                                "municEvaqueeNum":""
                            };
                        }
                    }

                    var className = '';
                    var tr = domConstruct.create('tr');

                    // 市町村
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.municipalityName, class: 'align-middle text-center fw-bold first-col'}), tr);

                    // 開設避難所数
                    className = shelterPrevItem && (shelterPrevItem.municOpeningShelterNum !== item.municOpeningShelterNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.municOpeningShelterNum + '</span>' + 'ヶ所', class: className}), tr);

                    // 避難世帯数
                    className = shelterPrevItem && (shelterPrevItem.municEvacHouseholdNum !== item.municEvacHouseholdNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.municEvacHouseholdNum + '</span>' + ' 世帯', class: className}), tr);

                    // 避難者数
                    className = shelterPrevItem && (shelterPrevItem.municEvaqueeNum !== item.municEvaqueeNum) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="fs-6 mx-2">' + item.municEvaqueeNum + '</span>' + ' 人', class: className}), tr);

                    domConstruct.place(tr, shelterOverviewTBody);
                });

                // 次回表示ページ
                if (lastIndex >= data.length - 1) {
                    // 先頭ページ
                    this._page = 0;
                } else {
                    // 次ページ
                    this._page += 1;
                }  

                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }

                // 定期更新処理
                this._timer = setTimeout(lang.hitch(this, function() {
                    self.setMunicShelterInfo(self, data);
                }), this.SIGNAGE_UPDATE_INTERVAL * 1000);
            }
        });
    });
